/** @file v1 → v2 migration: materialize `scenes[]` from legacy token/ball/drawings. */
import { shortId } from "../core/ids.js";

/**
 * Idempotent migration. If doc.schemaVersion is already 2, return unchanged.
 * Produces ONE scene snapshotting current tokens + ball; all drawings are visible
 * (v1 had no per-scene visibility concept).
 * @param {Record<string, unknown>} doc  raw shape from Firestore OR in-memory v1
 * @returns {Record<string, unknown>}
 */
export function migratePlayV1ToV2(doc) {
  if (doc.schemaVersion === 2) {
    return doc;
  }

  const tokens = Array.isArray(doc.tokens) ? doc.tokens : [];
  const drawings = Array.isArray(doc.drawings) ? doc.drawings : [];

  /** @type {Record<string, {x:number, y:number}>} */
  const posMap = {};
  /** @type {{x:number, y:number} | null} */
  let ball = null;

  for (const raw of tokens) {
    const t = /** @type {Record<string, unknown>} */ (raw);
    if (!t || typeof t !== "object") {
      continue;
    }
    const id = typeof t.id === "string" ? t.id : null;
    const x = typeof t.x === "number" ? t.x : 0;
    const y = typeof t.y === "number" ? t.y : 0;
    if (t.kind === "ball") {
      ball = { x, y };
      continue;
    }
    if (id) {
      posMap[id] = { x, y };
    }
  }

  /** @type {string[]} */
  const visibleArrowIds = drawings
    .map((d) => /** @type {Record<string, unknown>} */ (d)?.id)
    .filter((id) => typeof id === "string");

  const scene = {
    id: shortId(),
    tokens: posMap,
    ball,
    visibleArrowIds,
    durationMs: 2000,
  };

  return {
    ...doc,
    scenes: [scene],
    schemaVersion: 2,
  };
}
